/* eslint-disable react/no-unknown-property */
import * as React from "react"
import { Command as CommandPrimitive } from "cmdk"
import { Search } from "lucide-react"

import { cn } from "@/helpers/classNames"

function Command({
  className,
  ref,
  ...props
}: {
  ref?: React.Ref<React.ComponentRef<typeof CommandPrimitive>>
} & React.ComponentPropsWithoutRef<typeof CommandPrimitive>) {
  return (
    <CommandPrimitive
      ref={ref}
      className={cn(
        `
          flex size-full flex-col overflow-hidden rounded-md bg-popover
          text-popover-foreground
        `,
        className,
      )}
      {...props}
    />
  )
}

function CommandInput({
  className,
  ref,
  ...props
}: {
  ref?: React.Ref<React.ComponentRef<typeof CommandPrimitive.Input>>
} & React.ComponentPropsWithoutRef<typeof CommandPrimitive.Input>) {
  return (
    <div className="flex items-center border-b px-3" cmdk-input-wrapper="">
      <Search className="mr-2 size-4 shrink-0 opacity-50" />
      <CommandPrimitive.Input
        ref={ref}
        className={cn(
          `
            flex h-11 w-full rounded-md bg-transparent py-3 text-sm
            outline-hidden
            placeholder:text-muted-foreground
            disabled:cursor-not-allowed disabled:opacity-50
          `,
          className,
        )}
        {...props}
      />
    </div>
  )
}

function CommandList({
  className,
  ref,
  ...props
}: {
  ref?: React.Ref<React.ComponentRef<typeof CommandPrimitive.List>>
} & React.ComponentPropsWithoutRef<typeof CommandPrimitive.List>) {
  return (
    <CommandPrimitive.List
      ref={ref}
      className={cn(
        "max-h-[300px] overflow-x-hidden overflow-y-auto",
        className,
      )}
      {...props}
    />
  )
}

function CommandEmpty({
  ref,
  ...props
}: {
  ref?: React.Ref<React.ComponentRef<typeof CommandPrimitive.Empty>>
} & React.ComponentPropsWithoutRef<typeof CommandPrimitive.Empty>) {
  return (
    <CommandPrimitive.Empty
      ref={ref}
      className="py-6 text-center text-sm"
      {...props}
    />
  )
}

function CommandGroup({
  className,
  ref,
  ...props
}: {
  ref?: React.Ref<React.ComponentRef<typeof CommandPrimitive.Group>>
} & React.ComponentPropsWithoutRef<typeof CommandPrimitive.Group>) {
  return (
    <CommandPrimitive.Group
      ref={ref}
      className={cn(
        `
          overflow-hidden p-1 text-foreground
          **:[[cmdk-group-heading]]:px-2 **:[[cmdk-group-heading]]:py-1.5
          **:[[cmdk-group-heading]]:text-xs
          **:[[cmdk-group-heading]]:font-medium
          **:[[cmdk-group-heading]]:text-muted-foreground
        `,
        className,
      )}
      {...props}
    />
  )
}

function CommandItem({
  className,
  ref,
  ...props
}: {
  ref?: React.Ref<React.ComponentRef<typeof CommandPrimitive.Item>>
} & React.ComponentPropsWithoutRef<typeof CommandPrimitive.Item>) {
  return (
    <CommandPrimitive.Item
      ref={ref}
      className={cn(
        `
          relative flex cursor-default items-center rounded-sm px-2 py-1.5
          text-sm outline-hidden select-none
          aria-selected:bg-accent aria-selected:text-accent-foreground
          data-[disabled='true']:pointer-events-none
          data-[disabled='true']:opacity-50
        `,
        className,
      )}
      {...props}
    />
  )
}

export {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
}
